<h4 class="esf-heading esf-heading--low-level esf-action-heading esf-action-heading--low-level" style="margin-bottom: 0px">
  <span i18n='Communication section title@@customerOverviewComponent.sectionHeading.communicationData' class="esf-action-heading__text">Communication data</span>
  <span class="esf-action-heading__actions">
    <span class="esf-action-heading__action">
      <button class="esf-button esf-button--simple" [disabled]="customer.hasEmail ? spinnerLoading : false" (click)="editCommunication()" [edsTooltip]="tooltipTranslations.i18nEdit">
        <svg class="esf-icon esf-button__icon" width="16" height="16">
          <use xlink:href="#esf-icon-edit"></use>
        </svg>
        <span class="esf-button__icon-text"></span>
      </button>
    </span>
  </span>
</h4>
<div class="esf-info-tile customer-overview-box-width" style="flex: 1;">
  <div class="esf-info-tile__content">

    <div class="esf-icon-and-text esf-icon-and-text--xs">
      <svg class="esf-icon" width="16" height="16" [edsTooltip]="tooltipTranslations.i18nMobile">
        <use xlink:href="#esf-icon-tablet"></use>
      </svg>
      <div class="esf-icon-and-text__text mobile">{{ customer.mobile || '/' }}</div>
    </div>
    <div class="esf-icon-and-text esf-icon-and-text--xs">
      <svg class="esf-icon" width="16" height="16" [edsTooltip]="tooltipTranslations.i18nTelephone">
        <use xlink:href="#esf-icon-phone"></use>
      </svg>
      <div class="esf-icon-and-text__text phone">{{ customer.phone || '/' }}</div>
    </div>
    <div class="esf-icon-and-text esf-icon-and-text--xs" [ngSwitch]="customer.equalAuthorizationAndEmail">
      <ng-container *ngSwitchCase="true">
        <svg class="esf-icon" width="16" height="16" [edsTooltip]="tooltipTranslations.i18nEmailAuthorization">
          <use xlink:href="#esf-icon-mail-authorized"></use>
        </svg>
      </ng-container>

      <ng-container *ngSwitchCase="false">
        <svg class="esf-icon" width="16" height="16" [edsTooltip]="tooltipTranslations.i18nEmail">
          <use xlink:href="#esf-icon-mail"></use>
        </svg>
      </ng-container>

      <div class="esf-icon-and-text__text">
        <a class="esf-text--link email" href="mailto:{{ customer.email }}">{{ customer.email || '/' }}</a>
      </div>

    </div>
    <div class="esf-icon-and-text esf-icon-and-text--xs" *ngIf="this.selectedClub.isCampaignActive && showCampaignStatus">
      <svg class="esf-icon" width="16" height="16" [edsTooltip]="tooltipTranslations.i18nMarketingPermission">
        <use xlink:href="#esf-icon-megaphone-small"></use>
      </svg>
      <div class="esf-icon-and-text__text" *ngIf="!spinnerLoading">
        <span class="esf-tag" [ngClass]="campaignStatus.statusCssClass">{{ campaignStatus.translatedCampaignStatus }}</span>
      </div>
      <div class="esf-icon-and-text__text" *ngIf="spinnerLoading">
        <app-spinner [name]="spinnerName" [(show)]="spinnerLoading"></app-spinner>
      </div>
    </div>

  </div>
</div>